"use server";

import { parseWithZod } from "@conform-to/zod/v4";
import { redirect } from "next/navigation";

import { authErrorReply } from "@/lib/auth/errors";
import { startOAuth } from "@/lib/auth/oauth";
import { POST_AUTH_DEFAULT, safeNext, withNext } from "@/lib/auth/safe-next";
import { loginSchema } from "@/lib/auth/schemas";
import { getServerSupabase } from "@/lib/supabase/server";

export async function loginAction(_prev: unknown, formData: FormData) {
  const submission = parseWithZod(formData, { schema: loginSchema });
  if (submission.status !== "success") return submission.reply();

  const supabase = await getServerSupabase();
  const { error } = await supabase.auth.signInWithPassword({
    email: submission.value.email,
    password: submission.value.password,
  });
  if (error) return submission.reply(authErrorReply(error));

  redirect(safeNext(formData.get("next")?.toString(), POST_AUTH_DEFAULT));
}

// A provider error returns to /login WITH its next: /login is also the
// onboarding's sign-in leg, and dropping next would lose the flow + deep link.
async function loginOAuth(provider: "apple" | "google", formData: FormData) {
  const next = formData.get("next")?.toString();
  await startOAuth(provider, withNext("/login", next), next);
}

export async function loginWithGoogleAction(formData: FormData): Promise<void> {
  await loginOAuth("google", formData);
}

export async function loginWithAppleAction(formData: FormData): Promise<void> {
  await loginOAuth("apple", formData);
}
